import React from 'react';
import { styled } from '@mui/material/styles';
import EDFab from '../../BaseComponents/Fab/EDFab';
import EDIcon from '../../BaseComponents/Icon/EDIcon';
import {
  FLOATING_MENU_CLUSTER_MAX_WIDTH_PX,
  FLOATING_MENU_SAFE_AREA_PADDING_BOTTOM,
  FLOATING_MENU_SAFE_AREA_PADDING_LEFT,
  FLOATING_MENU_SAFE_AREA_PADDING_RIGHT,
} from './FloatingMenu';
import { useIsFloatingMenuMounted } from './FloatingMenuPresenceContext';

interface IMainMenuFabRootProps {
  standalone?: boolean;
}

const MainMenuFabRoot = styled('div', {
  name: 'MainMenuFab',
  slot: 'Root',
})(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  display: 'flex',
  justifyContent: 'center',
  boxSizing: 'border-box',
  paddingBottom: FLOATING_MENU_SAFE_AREA_PADDING_BOTTOM,
  paddingLeft: FLOATING_MENU_SAFE_AREA_PADDING_LEFT,
  paddingRight: FLOATING_MENU_SAFE_AREA_PADDING_RIGHT,
  pointerEvents: 'none',
  zIndex: theme.zIndex.fab,
}));

const MainMenuFabCluster = styled('div', {
  name: 'MainMenuFab',
  slot: 'Cluster',
  shouldForwardProp: prop => prop !== 'standalone',
})<IMainMenuFabRootProps>(({ standalone }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'flex-end',
  width: '100%',
  maxWidth: standalone ? '100%' : `${FLOATING_MENU_CLUSTER_MAX_WIDTH_PX}px`,
  pointerEvents: 'none',
  transition: 'max-width 300ms ease',
  '& > *': {
    pointerEvents: 'auto',
  },
}));

interface IProps {
  onClick: () => void;
  disabled?: boolean;
}

/** FAB button for opening the main menu on touch devices */
const MainMenuFab: React.FC<IProps> = ({ onClick, disabled }) => {
  const isMenuMounted = useIsFloatingMenuMounted();

  return (
    <MainMenuFabRoot>
      <MainMenuFabCluster standalone={!isMenuMounted}>
        <EDFab
          size="medium"
          color="secondary"
          glass
          onClick={onClick}
          disabled={disabled}
          testId="mainMenuFab"
        >
          <EDIcon iconType="menu" color="inherit" />
        </EDFab>
      </MainMenuFabCluster>
    </MainMenuFabRoot>
  );
};

export default MainMenuFab;
